import React from 'react';

import ImageBase from './ImageBase';

type TBackground = {
  src: string;
  alt: string;
  style?: React.CSSProperties;
  height?: string;
  className?: string;
};

const Background = ({ src, height, alt, style, ...rest }: TBackground) => {
  const modifiedStyle = {
    ...style,
    backgroundImage: `url(${src})`,
  };

  if (height) {
    modifiedStyle['height'] = `${height}px`;
  }

  return (
    <ImageBase
      {...rest}
      as="figure"
      kind="background"
      title={alt}
      alt={alt}
      forceImageContainer={!!src}
      style={{ ...modifiedStyle }}
    />
  );
};

export default Background;
